import { render, staticRenderFns } from "./SupplementalInformationCN.vue?vue&type=template&id=a2ac7952"
import script from "./SupplementalInformationCN.vue?vue&type=script&lang=js"
export * from "./SupplementalInformationCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports